/**
 * Contact Service
 *
 * Typed wrapper for the submitContactRequest Cloud Function.
 * UNAUTHENTICATED — the callable accepts requests from public visitors.
 */

import { httpsCallable } from 'firebase/functions';
import { initFirebaseClient } from '@copapp/firebase/client';

// ---------------------------------------------------------------------------
// Request / Response types
// ---------------------------------------------------------------------------

export interface ContactRequest {
  name: string;
  email: string;
  phone: string;
  organization: string;
  state: string;
  interest: string;
  message: string;
  /** Honeypot — should be empty for real submissions. */
  website: string;
}

export interface ContactResponse {
  success: boolean;
}

// ---------------------------------------------------------------------------
// Service function
// ---------------------------------------------------------------------------

/**
 * Submit a contact / grant-help request from the public landing page.
 * No auth required. Rate-limit errors surface as `functions/resource-exhausted`.
 */
export async function submitContactRequest(
  params: ContactRequest,
): Promise<ContactResponse> {
  const { functions } = initFirebaseClient();
  const fn = httpsCallable<ContactRequest, ContactResponse>(
    functions,
    'submitContactRequest',
  );
  const result = await fn(params);
  return result.data;
}
